<template>
  <div class="text-white text-center py-4">
    <Spinner v-if="loading" />
    <ContestLeaderboard
      v-else-if="ranking.length > 0"
      :loading="loading"
      :ranking="ranking"
      :leaderboard-length="leaderboardLength"
    />
    <div v-else class="flex flex-col items-center justify-center text-white/60">
      <Icon icon="material-symbols:trophy-outline" class="size-10 mb-4" />
      <p class="text-base font-medium">
        {{ $t("channel.leaderboard.winnersTab.noWinners") }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ContestLeaderboard, {
  ContestLeaderboardUserFragment,
} from "@/components/contest/contest-leaderboard.vue";
import { useQuery } from "@vue/apollo-composable";
import { ChannelLeaderboardDocument } from "@/generated/graphql";
import { useChannelStore } from "@/stores/channel.store";
import { useThemeStore } from "@/stores/theme.store";
import { LeaderboardLength } from "@f3/shared/leaderboard-types";
import { Icon } from "@iconify/vue";
import Spinner from "../ui/spinner.vue";
import type { ResultOf } from "@graphql-typed-document-node/core";

type ContestLeaderboardUser = ResultOf<typeof ContestLeaderboardUserFragment>;

const props = defineProps<{
  leaderboardLength: LeaderboardLength;
  startDate: Date;
  endDate: Date;
}>();

const channelStore = useChannelStore();
const _themeStore = useThemeStore();

const { result: leaderboard, loading } = useQuery(
  ChannelLeaderboardDocument,
  computed(() => ({
    channel_id: channelStore.channelSlug!,
    leaderboard_length: props.leaderboardLength,
    start_date: props.startDate.toISOString(),
    end_date: props.endDate.toISOString(),
    highlights: false,
    community_id: channelStore.selectedCommunity,
  })),
  { enabled: computed(() => !!channelStore.channelSlug) },
);

const ranking = computed(() => {
  const result =
    (leaderboard.value?.channelLeaderboard.__typename === "Leaderboard" &&
      leaderboard.value.channelLeaderboard.ranking) ||
    [];
  return result.map((r) => r as ContestLeaderboardUser);
});
</script>
